<template>
  <div id="app">
    <HelloWorld />
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "App",
  components: {
    HelloWorld
  }
};
</script>

<style scoped>
#app {
  padding: 0;
  margin: 0;
}
div {
  box-sizing: border-box;
}
</style>
<style lang="scss">
#webpack-dev-server-client-overlay {
  display: none;
}

.el-table .el-table__body tr:hover > td {
  // background-color: #091538 !important;
  font-weight: 400;
  font-size: 16px;
  color: #d4e6ff;
}
.el-table tr {
  // background-color: #091538 !important;
  font-weight: 400;
  font-size: 16px;
  color: #d4e6ff;
}
.el-table .el-table__fixed-body tr:hover > td {
  background-color: #091538 !important;
  font-weight: 400;
  font-size: 16px;
  color: #d4e6ff;
}

.el-table__body .el-table__row.hover-row td {
  // background-color: #091538 !important;
  font-weight: 400;
  font-size: 16px;
  color: #d4e6ff;
}
.el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: 1px solid #2f416b !important;
}
.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #2f416b !important;
}
.el-table {
  background-color: #0d193c;
  border: 1px solid #2f416b;
}

:deep(.el-checkbox__inner) {
  background: transparent;
  width: 24px;
  height: 24px;
}
:deep(.el-checkbox__inner::after) {
  top: 38%;
  left: 42%;
}
:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner::before) {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

:deep(.warning-row) {
  background: #0d193c;
  font-size: 16px;
  color: #d4e6ff;
}

:deep(.success-row) {
  background: #16264a;
  font-size: 16px;
  color: #d4e6ff;
}

/* 自定义表格滚动条样式 */
.el-table__body-wrapper::-webkit-scrollbar {
  width: 17px;
  height: 17px;
  border-radius: 20px;
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  background: #213456;
  border-radius: 4px;

}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #213456;
  border-radius: 8px;

}

.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #29456e;
  border-radius: 8px;

}
/* 自定义深色主题滚动条 */
.dark-theme .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #29456e;
  border-radius: 8px;

}

.el-table--border th.el-table__cell, .el-table__fixed-right-patch {
  // background: transparent !important;
  border-bottom: 1px solid transparent !important;

}

// .el-table--border th.el-table__cell, .el-table__fixed-right-patch {
//   border: 0 !important;
// }
:deep(.el-table__fixed-right-patch) {
  background: #213456 !important;
}

/* 滚动条整体部分 */
.over_flow_style::-webkit-scrollbar {
  width: 16px; /* 滚动条的宽度 */
  height: 16px; /* 滚动条的高度 */
}

/* 滚动条轨道 */
.over_flow_style::-webkit-scrollbar-track {
  background: #213456; /* 轨道颜色 */
}

/* 滚动条滑块 */
.over_flow_style::-webkit-scrollbar-thumb {
  background: #29456e; /* 滑块颜色 */
  border-radius: 10px; /* 滑块圆角 */
}

/* 滑块悬停状态 */
.over_flow_style::-webkit-scrollbar-thumb:hover {
  background: #29456e; /* 滑块悬停颜色 */
}

.writing {
  // overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /* 防止文本换行 */
}
.el-input__inner::placeholder {
  color: #ffffff !important; /* 修改为希望的文字颜色 */
}

// .el-message-box__content,.el-message-box__btns,.el-message-box__header {
//   background-color: #213456;
// }
// .el-message-box {
//   border: none !important;
// }
// .el-message-box__title {
//   color: #fff !important;
// }
</style>

